import { isNotNil } from 'es-toolkit';

/**
 * Check if the path indicates that a value was deleted from an array
 */
export const checkForDeletion = (fieldPathArray: PropertyKey[]): boolean => {
  const last = fieldPathArray.at(-1);
  return isNotNil(last) && isArrayIndex(last) && String(last).startsWith('_');
};

/**
 * Helper to trim leading underscore when determing if a field in a path is an array index
 */
export const trimLeadingUnderscore = (part: string | number): string | number =>
  String(part).startsWith('_') ? String(part).slice(1) : part;

/**
 * Helper to trim trailing array index if the final field in a path is an array index
 */
export const trimTrailingArrayIndex = (fieldPathArray: PropertyKey[]): PropertyKey[] => {
  const last = fieldPathArray.at(-1);
  return isNotNil(last) && isArrayIndex(last) ? fieldPathArray.slice(0, -1) : fieldPathArray;
};

/**
 * Check if a path part represents an array index
 */
export const isArrayIndex = (part: PropertyKey): boolean => {
  if (typeof part === 'symbol') return false;
  const trimmedPart = trimLeadingUnderscore(part);
  if (trimmedPart === '') return false; // Number('') returns 0
  return !Number.isNaN(Number(trimmedPart));
};
